import * as go from 'gojs'
import { majorGridLines, minorGridLines, grey500 } from '@/utils/constants'

var $ = go.GraphObject.make

function tdsGrid () {
  const dotted = [1, 2]
  return $(go.Panel, 'Grid',
    {
      background: grey500
    },
    $(go.Shape, 'LineH', { stroke: minorGridLines, strokeDashArray: dotted }),
    $(go.Shape, 'LineV', { stroke: minorGridLines, strokeDashArray: dotted }),
    $(go.Shape, 'LineH', { stroke: majorGridLines, strokeDashArray: dotted, interval: 5 }),
    $(go.Shape, 'LineV', { stroke: majorGridLines, strokeDashArray: dotted, interval: 5 })
  )
}

export { tdsGrid }



// WEBPACK FOOTER //
// ./src/graph_parts/grid.js